module.exports = __webpack_public_path__ + "img/26b)(Auswärtiges Amt) Montage von über 1500 Büros.jpg";